// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d74739ca","703":"c6cbad8c","787":"8f3946b0"}[chunkId] + ".chunk.js";
};